/* eslint-disable no-console */
import Script from 'next/script';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Avatar from '@deprecated-ui/common/Avatar';
import color from '@deprecated-ui/_style/color';
import useForm from 'hooks/useForm';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { effects as tippingEffects } from 'lib/entities/tipping';
import Image from 'global/Image';
import { AVATAR_URL, GOPAY_URL_JAVASCRIPT } from 'constants/api';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import ERROR_MESSAGE from 'constants/errorMessage';
import StreamTabAnalytics from 'features/stream/analytics/StreamTabAnalytics';
import { getAnalyticsPageSource } from 'utils/source';
import {
  ButtonSendTipping,
  ButtonTipping,
  InputAmountTipping,
  Modal,
  TextareaTippingMessage,
  TippingWrapper,
} from './styled';
import { MAX_TIPPING_AMOUNT } from '../constants';

interface ModalTippingProps {
  streamId: number;
  username: string;
  avatar: string;
  userId: number;
  onCancel?: () => void;
  [key: string]: any;
}

/**
 * Modal Tipping
 * @example
 * const streamId = 123;
 * const username = "stockbit";
 * const avatar = "someuseravatar.png";
 * <ModalTipping streamId={streamId} username={username} avatar={avatar} />
 */

function ModalTipping({
  streamId,
  userId,
  username,
  avatar,
  onCancel = () => {},
  ...props
}: ModalTippingProps) {
  const pageSource = getAnalyticsPageSource();
  const dispatch = useDispatch();

  const [amount, setAmount] = useState<number>(0);
  const [message, setMessage] = useForm({ initialState: '' });
  const [clientKey, setClientKey] = useState(null);

  const avatarUrl = avatar.startsWith('http') ? avatar : `${AVATAR_URL}/${avatar}`;

  const handleChangeAmount = (val) => {
    if (val.value !== '') {
      setAmount(parseFloat(val.value));
    } else {
      setAmount(0);
    }
  };

  const handleSetAmount = (val) => {
    setAmount(val);
    StreamTabAnalytics.common.Action.clickTippingAmount({
      streamId,
      userId,
    });
  };

  const handleSubmitTip = async () => {
    if (amount) {
      if (amount > MAX_TIPPING_AMOUNT) {
        handleErrorMessageAPI(
          ERROR_MESSAGE.TIPPING_MAX_AMOUNT_ERROR,
          ERROR_MESSAGE.ALERT_RED,
        );
      } else {
        const tipData = {
          tippable: {
            id: streamId,
            type: 'TYPE_STREAM',
          },
          amount,
          message,
          // callback_url: window?.location?.href,
        };
        // @ts-ignore
        const sendTip = await dispatch(tippingEffects.sendTipping(tipData));
        // @ts-ignore
        const { error, data = null } = sendTip.payload;

        if (!error && data) {
          if (pageSource) {
            StreamTabAnalytics.common.Action.clickSubmitTip({
              pageSource,
              amount,
              message,
              postid: streamId,
              userId,
              username,
            });
          }
          // const { action } = data;
          setClientKey(data.client_key);

          // eslint-disable-next-line no-undef
          snap.pay(data.snap_token, {
            onSuccess() {
              console.log('snapSuccess');
              // console.log(result);
              onCancel();
            },
            onPending() {
            // console.log('snapPending');
            // console.log(result);
              onCancel();
            },
            onError() {
              console.log('snapError');
              // console.log(result);
              onCancel();
            },
            onClose() {
              onCancel();
              console.log(
                'customer closed the popup without finishing the payment',
              );
            },
          });
        }
      }
    }
  };

  return (
    <>
      <Script
        src={GOPAY_URL_JAVASCRIPT}
        data-client-key={clientKey}
      />
      <Modal
        {...props}
        onCancel={onCancel}
        centered
        footer={null}
        width={400}
        maskStyle={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
      >
        <TippingWrapper>
          <Text align="center" weight="bold" size="16px">
            Isi jumlah tip
          </Text>
          <Text align="center" size="12px" color={color.midgray}>
            untuk {username}
          </Text>
          <Flex justify="center">
            <Avatar size="large" padding="15px 0 0">
              <Image alt="" src={avatarUrl} />
            </Avatar>
          </Flex>
          <Text padding="12px 0">Jumlah tip</Text>
          <Flex justify="space-between" margin="0 0 15px">
            <ButtonTipping
              isSelected={amount === 5000}
              onClick={() => handleSetAmount(5000)}
            >
              Rp5,000
            </ButtonTipping>
            <ButtonTipping
              isSelected={amount === 10000}
              onClick={() => handleSetAmount(10000)}
            >
              Rp10,000
            </ButtonTipping>
            <ButtonTipping
              isSelected={amount === 20000}
              onClick={() => handleSetAmount(20000)}
            >
              Rp20,000
            </ButtonTipping>
          </Flex>
          <InputAmountTipping
            value={amount === 0 ? '' : amount}
            thousandSeparator
            prefix="Rp"
            onValueChange={handleChangeAmount}
            allowNegative={false}
            name="tipAmount"
            placeholder="Masukkan jumlah tip disini"
            className="ant-input"
          />
          <Text padding="18px 0 12px 0" size="12px">
            Pesan
          </Text>
          <TextareaTippingMessage
            value={message}
            onChange={(e) => {
              setMessage(e);
              StreamTabAnalytics.common.Action.changeTippingMessage();
            }}
            rows={4}
            placeholder="Isi pesan"
            // @ts-expect-error
            height="62px"
          />
          <ButtonSendTipping
            block
            type="primary"
            margin="20px 0 0"
            height="40px"
            // @ts-expect-error
            round
            onClick={handleSubmitTip}
            disabled={amount === 0}
          >
            <Text align="center" color={color.light} family="bold">
              Kirim dengan GO-PAY
            </Text>
          </ButtonSendTipping>
        </TippingWrapper>
      </Modal>
    </>
  );
}

export default ModalTipping;
